/**
 * Icons offered for `dev.roe.project.icon`. Project records live on the PDS, so
 * nothing in the source tree references these classes and UnoCSS can't discover
 * them; `uno.config.ts` safelists this list and the admin editor offers exactly
 * the same set. Adding an icon here is what makes it available to pick.
 */
export const projectIcons = [
  'i-ri:archive-line',
  'i-ri:archive-stack-line',
  'i-ri:arrow-up-circle-line',
  'i-ri:braces-line',
  'i-ri:bubble-chart-line',
  'i-ri:cpu-line',
  'i-ri:css3-line',
  'i-ri:dashboard-3-line',
  'i-ri:database-2-line',
  'i-ri:database-line',
  'i-ri:error-warning-line',
  'i-ri:exchange-line',
  'i-ri:file-zip-line',
  'i-ri:filter-off-line',
  'i-ri:flashlight-line',
  'i-ri:folder-download-line',
  'i-ri:font-family',
  'i-ri:font-size',
  'i-ri:keyboard-line',
  'i-ri:link',
  'i-ri:list-ordered',
  'i-ri:magic-line',
  'i-ri:reactjs-line',
  'i-ri:refresh-line',
  'i-ri:restaurant-line',
  'i-ri:route-line',
  'i-ri:server-line',
  'i-ri:shield-check-line',
  'i-ri:shield-keyhole-line',
  'i-ri:text-spacing',
  'i-ri:toggle-line',
  'i-ri:vidicon-line',
  'i-ri:walk-line',
  'i-tabler:brand-nuxt',
] as const
